import { gql } from '@apollo/client';

const PRICE_RULE_FIELDS = gql`
  fragment PriceRuleFields on PriceRule {
    id
    subject_kind
    subject_id
    branch_id
    priority
    predicate_json
    price_cents
    note
    status
    created_at
    updated_at
  }
`;

export const PRICE_RULES_QUERY = gql`
  ${PRICE_RULE_FIELDS}
  query PriceRules(
    $offset: Int
    $limit: Int
    $search: String
    $subject_kind: PriceRuleSubjectKind
    $subject_id: ID
    $branch_id: ID
    $status: PriceRuleStatus
  ) {
    priceRules(
      offset: $offset
      limit: $limit
      search: $search
      subject_kind: $subject_kind
      subject_id: $subject_id
      branch_id: $branch_id
      status: $status
    ) {
      items {
        ...PriceRuleFields
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const PRICE_RULE_SUBJECTS_LOOKUP = gql`
  query PriceRuleSubjectsLookup {
    products(limit: 200, status_filter: ALL) {
      items { id code name }
    }
    services(limit: 200, status_filter: ALL) {
      items { id code name }
    }
    kits(limit: 200, status_filter: ALL) {
      items { id code name }
    }
    branches { id name }
  }
`;

export const PRICE_RULE_SUBJECT_SEARCH_QUERY = gql`
  query PriceRuleSubjectSearch($term: String!) {
    searchSellable(input: { term: $term, limit: 20 }) {
      kind
      id
      code
      name
    }
  }
`;

export const CREATE_PRICE_RULE_MUTATION = gql`
  ${PRICE_RULE_FIELDS}
  mutation CreatePriceRule($input: CreatePriceRuleInputGql!) {
    createPriceRule(input: $input) {
      ...PriceRuleFields
    }
  }
`;

export const UPDATE_PRICE_RULE_MUTATION = gql`
  ${PRICE_RULE_FIELDS}
  mutation UpdatePriceRule($id: ID!, $input: UpdatePriceRuleInputGql!) {
    updatePriceRule(id: $id, input: $input) {
      ...PriceRuleFields
    }
  }
`;

export const DEACTIVATE_PRICE_RULE_MUTATION = gql`
  ${PRICE_RULE_FIELDS}
  mutation DeactivatePriceRule($id: ID!) {
    deactivatePriceRule(id: $id) {
      ...PriceRuleFields
    }
  }
`;
